import { render, staticRenderFns } from "./SchoolYearTabs.vue?vue&type=template&id=a33a2ca0"
import script from "./SchoolYearTabs.vue?vue&type=script&lang=js"
export * from "./SchoolYearTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports